import { render, staticRenderFns } from "./GlobalJumpPalette.vue?vue&type=template&id=06b53504&scoped=true&"
import script from "./GlobalJumpPalette.vue?vue&type=script&lang=ts&"
export * from "./GlobalJumpPalette.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalJumpPalette.vue?vue&type=style&index=0&id=06b53504&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b53504",
  null
  
)

export default component.exports